"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CdpCommands = void 0;
const commands_1 = require("./commands");
class CdpCommands {
    constructor(config) {
        this.config = config;
    }
    doTrackSignInEvent(input) {
        const command = new commands_1.SignInCommand(input);
        return command.execute(this.config);
    }
    doTrackSignUpEvent(input) {
        const command = new commands_1.SignUpCommand(input);
        return command.execute(this.config);
    }
    doTrackIdentifyUserEvent(input) {
        const command = new commands_1.IdentifyUserCommand(input);
        return command.execute(this.config);
    }
    doTrackViewContentEvent(input) {
        const command = new commands_1.ViewContentCommand(input);
        return command.execute(this.config);
    }
    doTrackAddToCartEvent(input) {
        const command = new commands_1.AddToCartCommand(input);
        return command.execute(this.config);
    }
    doTrackRemoveFromCartEvent(input) {
        const command = new commands_1.RemoveFromCartCommand(input);
        return command.execute(this.config);
    }
    doTrackSearchEvent(input) {
        const command = new commands_1.SearchCommand(input);
        return command.execute(this.config);
    }
    doTrackInitiateCheckoutEvent(input) {
        const command = new commands_1.InitiateCheckoutCommand(input);
        return command.execute(this.config);
    }
    doTrackAddPaymentInfoEvent(input) {
        return Promise.resolve();
    }
    doTrackPurchaseEvent(input) {
        return Promise.resolve();
    }
    doTrackPromotionCodeUsedEvent(input) {
        const command = new commands_1.PromotionCodeUsedCommand(input);
        return command.execute(this.config);
    }
    doTrackEventByConversionApi(input) {
        return Promise.resolve();
    }
    doTrackFestivalFormStartEvent(_input) {
        return Promise.resolve();
    }
    doTrackFestivalSuccessEvent(_input) {
        return Promise.resolve();
    }
}
exports.CdpCommands = CdpCommands;
